import React, { useEffect, useRef, useState } from 'react';
import { WeatherDataItem, WeatherPropertyCodes, useWeatherData } from './hooks/useWeatherData';

export interface WeaterForcastWindDirectionProps {
  weatherData: WeatherDataItem[] | null;
  show: boolean | null;
}

// ---------------------------------------------
//  WeaterForcastWindDirection
// ---------------------------------------------

const WeaterForcastWindDirection = ({ weatherData, show }: WeaterForcastWindDirectionProps) => {
  const [windData, setWindData] = useState<any | null>();
  const [windDirection, setWindDirection] = useState<any | null>(windData);
  const [loop, setLoop] = useState<number | null>(null);

  // ---------------------------------------------
  //  useEffect - weatherData
  // ---------------------------------------------

  useEffect(() => {
    return () => {
      if (loop) {
        window.cancelAnimationFrame(loop);
        setLoop(null);
      }
    };
  }, []);

  useEffect(() => {
    if (weatherData) {
      setWindData(weatherData?.find((item) => item.name === WeatherPropertyCodes.wd)?.values[0]);
    }

    return () => {
      if (loop) {
        window.cancelAnimationFrame(loop);
        setLoop(null);
      }
    };
  }, [weatherData]);

  useEffect(() => {
    if (windData) {
      setLoop(window.requestAnimationFrame(() => changeWindDirection()));
    }
  }, [windData]);

  // ---------------------------------------------
  //  changeWindDirection - arrow animation
  // ---------------------------------------------
  const changeWindDirection = async () => {
    const frameRate = 30;
    let then = performance.now();
    const interval = 1000 / frameRate;
    let delta = 0;
    while (true) {
      let now = await new Promise(requestAnimationFrame);
      if (now - then < interval - delta) {
        continue;
      }
      delta = Math.min(interval, delta + now - then - interval);
      then = now;

      const pos = Math.floor(Math.random() * 7);

      if (pos === 0) {
        setWindDirection(windData);
      }
      if (pos === 1) {
        setWindDirection(windData + Math.floor(10 + Math.random() * 40));
      }
      if (pos === 2) {
        setWindDirection(windData - Math.floor(10 + Math.random() * 40));
      }
    }
  };

  return windDirection !== 0 ? (
    <div className={`weather-block-forcast-wind ${show ? 'show' : ''}`}>
      <img
        className="forcast-wind-arrow"
        alt="weather-symbol"
        src="/assets/icons/weather/windarrow_white.svg"
        style={{ transform: `rotate(${windDirection}deg)` }}
      />
    </div>
  ) : null;
};

export default WeaterForcastWindDirection;
